/**
 * License Verification Plugin
 * 
 * Verifies that the frontend is running on a licensed domain.
 * The LICENSED_DOMAIN should be set at build time for client distributions.
 */

// Configure these values when building for a specific client
// For your own use, leave as empty string to disable frontend check
const LICENSED_DOMAIN = process.env.VUE_APP_LICENSED_DOMAIN || '';

const LicenseCheck = {
    install(Vue) {
        // Skip if no domain configured (development mode)
        if (!LICENSED_DOMAIN) {
            return;
        }

        // Check domain on app load
        const currentHost = window.location.hostname.toLowerCase();
        const licensedDomain = LICENSED_DOMAIN.toLowerCase().replace(/^www\./, '');
        const currentDomainClean = currentHost.replace(/^www\./, '');

        // Allow localhost for development
        const isLocalhost = ['localhost', '127.0.0.1'].includes(currentHost) ||
            currentHost.includes('.local');

        if (isLocalhost) {
            return;
        }

        // Check if domains match
        let isValid = false;

        // Exact match
        if (currentDomainClean === licensedDomain) {
            isValid = true;
        }

        // Wildcard subdomain match (*.example.com)
        if (licensedDomain.startsWith('*.')) {
            const baseDomain = licensedDomain.substring(2);
            if (currentDomainClean.endsWith(baseDomain)) {
                isValid = true;
            }
        }

        if (!isValid) {
            // Block the entire application
            Vue.config.errorHandler = () => { };
            document.body.innerHTML = `
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #1e1e2f 0%, #1a1a2e 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #ffffff;
        ">
          <h1 style="color: #e14eca; margin-bottom: 20px;">⚠️ License Error</h1>
          <p style="color: #9a9a9a; font-size: 18px;">
            This application is not licensed for this domain.
          </p>
          <p style="color: #6c6c6c; font-size: 14px; margin-top: 40px;">
            Contact <a href="https://mrzakaria.com" target="_blank" style="color: #1d8cf8; text-decoration: underline;"><strong>MrZaKaRiA</strong></a> to obtain a valid license.
          </p>
        </div>
      `;
            throw new Error('License verification failed: Domain not authorized');
        }
    }
};

export default LicenseCheck;
